var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11957 10.3801C6.92957 10.3801 6.73957 10.3101 6.58957 10.1601L5.83957 9.41007C5.54957 9.12007 5.54957 8.64007 5.83957 8.35007C6.12957 8.06007 6.60957 8.06007 6.89957 8.35007L7.11957 8.57007L8.83957 6.85007C9.12957 6.56007 9.60957 6.56007 9.89957 6.85007C10.1896 7.14007 10.1896 7.62007 9.89957 7.91007L7.64957 10.1601C7.50957 10.3001 7.31957 10.3801 7.11957 10.3801Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6201 9.62012H12.3701C11.9601 9.62012 11.6201 9.28012 11.6201 8.87012C11.6201 8.46012 11.9601 8.12012 12.3701 8.12012H17.6201C18.0301 8.12012 18.3701 8.46012 18.3701 8.87012C18.3701 9.28012 18.0401 9.62012 17.6201 9.62012Z",
    fill: "#5D9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3701 16.6201H17.6201C18.0401 16.6201 18.3701 16.2801 18.3701 15.8701C18.3701 15.4601 18.0301 15.1201 17.6201 15.1201H12.3701C11.9601 15.1201 11.6201 15.4601 11.6201 15.8701C11.6201 16.2801 11.9601 16.6201 12.3701 16.6201Z",
    fill: "#5D9FE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11957 17.3801C6.92957 17.3801 6.73957 17.3101 6.58957 17.1601L5.83957 16.4101C5.54957 16.1201 5.54957 15.6401 5.83957 15.3501C6.12957 15.0601 6.60957 15.0601 6.89957 15.3501L7.11957 15.5701L8.83957 13.8501C9.12957 13.5601 9.60957 13.5601 9.89957 13.8501C10.1896 14.1401 10.1896 14.6201 9.89957 14.9101L7.64957 17.1601C7.50957 17.3001 7.31957 17.3801 7.11957 17.3801Z",
    fill: "#5D9FE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 22.75H15C20.43 22.75 22.75 20.43 22.75 15V9C22.75 3.57 20.43 1.25 15 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75ZM2.75 9C2.75 4.39 4.39 2.75 9 2.75H15C19.61 2.75 21.25 4.39 21.25 9V15C21.25 19.61 19.61 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V9Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSquare);
export default __webpack_public_path__ + "static/media/Task_Square.fc386004e5bbbe2ed1290f1bdc62a7d4.svg";
export { ForwardRef as ReactComponent };